import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ChangelogList from './ChangelogList';
import * as changelogActions from '../../actions/changelogActions';
import * as pendingPageActions from '../../actions/pendingPageActions';

class ChangelogContainer extends React.Component {

    constructor(props) {
        super(props);
        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        this.props.actions.performRequiredActions(this, [
            this.props.actions.loadChangelog(1)
        ], false, false);
    }

    onPageChange(page) {
        this.props.actions.loadChangelog(page.selected + 1)
    }

    render() {
        let {
            changelog: {
                data: changes,
                total,
                page,
            },
        } = this.props;

        return <ChangelogList
            changes={changes}
            total={total}
            page={page}
            onPageChange={this.onPageChange}
        />
    }
}

function mapStateToProps(state, ownProps) {
    return {
        changelog: state.changelog,
        user: state.user,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...changelogActions,
            ...pendingPageActions,
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangelogContainer);


// WEBPACK FOOTER //
// ./web/src/components/dashboard/ChangelogContainer.jsx